var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promo_scale"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1478 40H5.85223C2.6335 40 0 37.3665 0 34.1478V5.85223C0 2.6335 2.6335 0 5.85223 0H34.1478C37.3665 0 40 2.6335 40 5.85223V34.1478C40 37.3665 37.3665 40 34.1478 40Z",
    fill: "#00AFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1_",
    d: "M30.9883 18.4345V33.2699C30.9883 34.0014 31.7198 34.6159 32.5684 34.6159C33.4462 34.6159 34.1485 34.0014 34.1485 33.2699V18.4345C34.1485 17.703 33.417 17.0885 32.5684 17.0885C31.7198 17.0592 30.9883 17.703 30.9883 18.4345Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3_1_",
    d: "M23.2041 13.0504V32.8309C23.2041 33.7966 23.9356 34.6451 24.9305 34.6451C25.9546 34.6451 26.6569 33.7966 26.6569 32.8309V13.0504C26.6569 12.0848 25.9254 11.2362 24.9305 11.2362C23.9356 11.2069 23.2041 12.0555 23.2041 13.0504Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4_1_",
    d: "M16.972 18.6686C15.8601 18.0833 14.6018 17.4981 13.4899 17.0592C12.7877 16.7666 12.2317 16.3277 11.6757 15.8888C10.5638 15.0109 10.7101 13.5479 12.0854 12.8163C12.378 12.67 12.7877 12.67 13.1973 12.67C14.7482 12.5237 16.1234 12.8163 17.528 13.5479C18.2302 13.8405 18.3765 13.8405 18.6399 12.9626C18.9325 12.2311 19.0495 11.3533 19.3422 10.6217C19.4885 10.0365 19.3422 9.74391 18.7862 9.4513C17.9376 9.15869 16.972 8.86608 16.1234 8.71977C14.8652 8.57346 14.8652 8.57346 14.8652 7.25671C14.8652 5.35474 14.8652 5.35474 13.051 5.35474C12.7584 5.35474 12.495 5.35474 12.3487 5.35474C11.5002 5.35474 11.3831 5.50104 11.3831 6.37888C11.3831 6.81779 11.3831 7.11041 11.3831 7.54932C11.3831 8.71977 11.3831 8.71977 10.2712 9.01238C7.75474 10.0365 6.23316 11.9385 5.94055 14.7183C5.79424 17.3518 7.05247 19.1075 9.15927 20.2779C10.4175 21.0095 11.822 21.4484 13.0803 22.1799C13.6362 22.4725 14.0459 22.6188 14.4848 23.0577C15.743 24.0819 15.4504 25.9839 14.0751 26.7154C13.2266 27.1543 12.4073 27.1543 11.5587 27.008C10.1542 26.8617 8.89592 26.4228 7.63769 25.8375C6.93543 25.3986 6.67208 25.5449 6.52577 26.4228C6.37946 27.1543 6.11611 27.8858 5.96981 28.4711C5.6772 29.3489 5.8235 29.6415 6.67208 30.0804C7.784 30.6656 8.89592 30.9582 10.1542 31.1046C11.1198 31.2509 11.1198 31.2509 11.1198 32.275C11.1198 32.7139 11.1198 33.1528 11.1198 33.5918C11.1198 34.3233 11.4124 34.6159 11.9683 34.6159C12.6706 34.6159 13.2266 34.6159 13.9288 34.6159C14.4848 34.6159 14.7774 34.3233 14.7774 33.7381C14.7774 33.1528 14.7774 32.4213 14.7774 31.8361C14.7774 31.2509 15.07 30.8119 15.626 30.6656C17.0305 30.2267 18.1424 29.4952 18.991 28.3247C21.3027 25.2523 20.4833 20.7168 16.972 18.6686Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoScale);
export default __webpack_public_path__ + "static/media/promo_scale.09204d50b9e2e859bbf34fa1d4f51a6e.svg";
export { ForwardRef as ReactComponent };